/* eslint no-async-promise-executor: 0 */  // --> OFF
import {app} from './main' 
import axios from 'axios'
import {getToken, setSessionStorage} from './sessionStorage'
import {globalPassActions} from '@/globalPass'
import {empty} from '@/helpers'

/*
params:{
    "url":"",
    "params":{},
    "method": "POST"|"GET"|"PUT"|"DELETE",
    "validate": true|false
}
*/

export async function request (params) {
  return new Promise(async function (resolve, reject) {
    const url = params.url || ''
    const data = params.params || ''
    const method = params.method || 'GET'
    let validate = params.validate
    const config = {
      headers:{
        Authorization: '',
        Verification: ''
      }
    }
    let token
    params.validate === undefined && (validate = true)
    config.headers.Verification = globalPassActions.get()

    if (validate) {
      token = getToken()
      config.headers.Authorization = `Bearer ${token}`
    }

    switch (method) {
    case 'GET':
      app.$vs.loading()  
      let tempdata = '?'
      for (const prop in data) {
        if (!empty(data[prop])) tempdata += `${prop}=${data[prop]}&`
      }
      tempdata = tempdata.slice(0, -1)
      axios.get(`${process.env.VUE_APP_API_URL + url}${tempdata}`, config)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        }).finally((r) => {
          app.$vs.loading.close() 
        })
      break
    case 'POST':
      app.$vs.loading()  
      axios.post(`${process.env.VUE_APP_API_URL}${url}`,
        data, config)
        .then(response => {
          app.$vs.notify({
            title:'¡Éxito!',
            position:'top-center',
            time:8000,
            text:'Agregado con éxito',
            color:'success',
            icon:'done'
          })
          resolve(response)
        }).catch(error => {
          app.$vs.notify({
            title:'¡Error!',
            position:'top-center',
            time:8000,
            text:'Ha ocurrido un error, por favor intente de nuevo.',
            color:'danger',
            icon:'warning'
          })
          reject(error)
        }).finally((r) => {
          app.$vs.loading.close() 
        })
      break
    case 'PUT':
      app.$vs.loading()  
      axios.put(`${process.env.VUE_APP_API_URL}${url}`,
        data, config)
        .then(response => {
          app.$vs.notify({
            title:'¡Éxito!',
            position:'top-center',
            time:8000,
            text:'Actualización con éxito',
            color:'success',
            icon:'done'
          })
          resolve(response)
        }).catch(error => {
          app.$vs.notify({
            title:'¡Error!',
            position:'top-center',
            time:8000,
            text:'Ocurrió un error al actualizar',
            color:'danger',
            icon:'warning'
          })
          reject(error)
        }).finally(() => {
          app.$vs.loading.close() 
        })
      break
    case 'DELETE':
      app.$vs.loading() 
      config.data = data
      axios.delete(`${process.env.VUE_APP_API_URL}${url}`, config)
        .then(response => {
          app.$vs.notify({
            title:'¡Éxito!',
            position:'top-center',
            time:8000,
            text:'Se ha elimindado con éxito',
            color:'success',
            icon:'done'
          })
          resolve(response)
        }).catch(error => {
          app.$vs.notify({
            title:'¡Error!',
            position:'top-center',
            time:8000,
            text:'Ocurrió un error al eliminar',
            color:'danger',
            icon:'warning'
          })
          reject(error)
        }).finally(() => {
          app.$vs.loading.close() 
        })
      break
    case 'FILE':
      app.$vs.loading() 
      axios({
        url: `${process.env.VUE_APP_API_URL}${url}`,
        method: 'GET',
        responseType: 'blob',
        headers: config.headers
      }).then((response) => {
        resolve(response)
      }).catch(error => {
        app.$vs.notify({
          title:'¡Error!',
          position:'top-center',
          time:8000,
          text:'Ocurrió un error al eliminar',
          color:'danger',
          icon:'warning'
        })
        reject(error)
      }).finally(() => {
        app.$vs.loading.close() 
      })
      break
    default:
      break
    }
  })
}
